import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { clearAuthCache } from '../layouts/AuthGate';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const redirectTo = (loc.state as { from?: string } | null)?.from ?? '/dashboard';

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      await api.post('/auth/login', { email, password });
      clearAuthCache();
      nav(redirectTo, { replace: true });
    } catch (e) {
      setErr((e as Error).message);
    } finally {
      setBusy(false);
    }
  }

  const [isGrantor, setIsGrantor] = useState(false);
  useEffect(() => {
    let live = true;
    fetch('/api/brand')
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => {
        if (!live || j?.deployment_kind !== 'grantor') return;
        setIsGrantor(true);
        // index.html ships one static title for every image; the browser tab is the
        // first thing on screen and should not say the wrong product either.
        document.title = 'Milestone Grantor';
      })
      .catch(() => {});
    return () => { live = false; };
  }, []);

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
          <span style={{
            width: 36, height: 36, borderRadius: 8,
            background: 'linear-gradient(135deg, #0ea5e9, #6366f1)',
            color: '#0b1220', fontWeight: 800, fontSize: 20,
            display: 'grid', placeItems: 'center',
          }}>M</span>
          <h1 style={{ margin: 0 }}>Milestone <b style={{ fontWeight: 800 }}>{isGrantor ? 'Grantor' : 'Build'}</b></h1>
        </div>
        <p>{isGrantor
          ? 'Award oversight, de-scope review, and the release record — for state broadband offices.'
          : 'Fiber design, construction, BEAD compliance — for ISPs.'}</p>

        <div className="form-field">
          <label>Email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            autoComplete="email"
          />
        </div>
        <div className="form-field">
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </div>

        {err && <div style={{ color: 'var(--danger)', fontSize: 13, marginBottom: 10 }}>{err}</div>}

        <button className="btn btn--primary" type="submit" disabled={busy} style={{ width: '100%', justifyContent: 'center' }}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
